export default {
  // Common labels used in multiple modules
  'global.advertisement': 'pubblicità',
  'global.cancel': 'Annulla',
  'global.confirm': 'Conferma',
  'global.continue': 'Continua',
  'global.video': 'Video',

  // Preact AudioPlayer component
  'audio.listen.text': 'ascolta articolo',
  'audio.player.not.active': 'player non attivo',

  // Preact BannerPrivacy component
  'bannerPrivacy.confirmText': 'OK',
  'bannerPrivacy.text':
    "Se prosegui con la navigazione o clicchi OK acconsenti all'uso da parte di Sky dei cookie tecnici, analitici, di profilazione di prima e terza parte, che sono usati per capire i contenuti che ti interessano e inviarti pubblicità in linea con le tue preferenze. Se vuoi saperne di più sui cookie e su come puoi disattivarli leggi ",
  'bannerPrivacy.text2': "la nostra Cookie Policy. Per leggere l'Informativa Privacy clicca ",
  'bannerPrivacy.textClickHere': 'qui',

  // Socials
  'socials.facebook': 'Facebook',
  'socials.twitter': 'Twitter',
  'socials.whatsapp': 'Whatsapp',
  'socials.telegram': 'Telegram',
  'socials.copy': 'Copia link',
  'social.share': 'Condividi',
  'social.copied.link': 'Link copiato',

  // video-player module
  'video.player.share.on.twitter': 'Condividi su Twitter',

  // video-playlist module
  'video.playlist.error': 'spiacenti si è verificato un errore',
  'video.playlist.next.video': 'Prossimo video',

  // Web Push Notifications
  'wpn.unsubscribe.title': "Revoca l'iscrizione alle notifiche",
  'wpn.confirm.dialog.title': 'Arriva sempre primo',
  'wpn.confirm.dialog.accept': 'ACCETTA',
  'wpn.confirm.dialog.cancel': 'Forse dopo',
  'wpn.sport.confirm.dialog.description':
    'Ricevi live da <strong>SkySport</strong> tutte le <strong>breaking news</strong>, le notizie sulla tua <strong>squadra del cuore</strong> e sui tuoi <strong>sport preferiti</strong>. Per accettare le notifiche devi dare il consenso.',
  'wpn.entertainment.confirm.dialog.description':
    'Ricevi live da <strong>Sky TG24</strong> tutte le news dal<strong>mondo dello spettacolo</strong>. Per accettarele notifiche devi dare il consenso.',
  'wpn.tg24.confirm.dialog.description':
    'Ricevi live da <strong>Sky TG24</strong> le breaking neews sui <strong>principali eventi</strong>Per accettare le notifiche devi dare il consenso.',
  'wpn.confirm.dialog.success.title': 'Hai impostato correttamente le tue notifiche',
  'wpn.preferences.dialog.title': 'Scegli quali notifiche ricevere',
  'wpn.preferences.unsub.dialog.title': 'Sei sicuro di non volere ricevere più le notifiche?',
  'wpn.preferences.unsub.dialog.confirm': 'Sì, sono sicuro',
  'wpn.preferences.unsub.dialog.cancel': 'Ho cambiato idea',
  'wpn.preferences.unsub.success.dialog.title': 'Ti sei disiscritto correttamente!',
  'wpn.preferences.dialog.latestNews-v1.select.box.message': 'Ricevi le breaking news di Sky TG24',
  'wpn.preferences.dialog.latestNews-v2.select.box.message':
    'Resta sempre aggiornato. Ricevi anche le breaking news di Sky TG24.',
  'wpn.preferences.dialog.entertainment-v1.select.box.message':
    'Sei appassionato di Spettacolo? Ricevi le ultime notizie di cinema, TV, musica, moda.',
  'wpn.preferences.dialog.entertainment-v2.select.box.message': 'Ricevi le ultime notizie di cinema, TV, musica, moda.',

  // Preferences Page
  'mysport.confirm.label': 'conferma sport',
  'myteam.confirm.label': 'conferma squadra',
  'newsletters.confirm.label': 'invia richiesta',
  'newsletters.subscription.pending.label': 'Richiesta attivazione presa in carico.',
  'newsletters.unsubscription.pending.label': 'Richiesta disattivazione presa in carico.',
  'mylocalnews.confirm.label': 'conferma regione',
  'mysport.confirm.message': 'Hai selezionato <b>%s</b> sport',
  'myteam.confirm.message': 'Hai selezionato <b>%s</b> squadra',
  'mylocalnews.confirm.message': 'Hai selezionato <b>%s</b> regioni',
  'tabs.premium': 'insider',
  'tabs.personalize': 'area personale',
  'status.notification.message.WPN': 'Hai impostato correttamente le tue notifiche',
  'status.notification.message.set.myteam': 'Hai impostato correttamente la tua squadra',
  'status.notification.message.set.mysport': 'Hai impostato correttamente i tuoi sport',
  'status.notification.message.set.mylocalnews': 'Hai impostato correttamente le tue local news',
  'status.notification.message.set.newsletters.success':
    'Abbiamo preso in carico la tua richiesta. Torna più tardi per avere aggiornamenti.',
  'status.notification.message.set.newsletters.failure': 'Qualcosa è andato storto. Riprova più tardi.',
  'status.notification.message.remove.myteam': 'Hai cancellato correttamente la tua squadra',
  'status.notification.message.remove.mysport': 'Hai cancellato correttamente il tuo sport',
  'status.notification.message.remove.mylocalnews': 'Hai cancellato correttamente le tue local news',
  'status.notification.message.remove.WPN':
    'Hai cancellato correttamente le tue notifiche. Potrai impostarle nuovamente in qualsiasi momento.',
  'contents.dropdown.option.go.to.section': 'Vai alla sezione',
  'contents.dropdown.option.edit.parselyMyTeam': 'Modifica squadra',
  'contents.dropdown.option.edit.parselyMySport': 'Modifica sport',
  'contents.dropdown.option.edit.parselyMyLocalNews': 'Modifica regione',

  // Premium
  'premium.title1': 'Sky Sport Insider',
  'premium.title2': 'Sky TG24 Insider',

  'premium.description1': 'Gestisci il piano di sottoscrizione.',
  'premium.description2':
    'Il nuovo spazio editoriale di approfondimento esclusivo: storie inedite, retroscena e opinioni raccontati dalle firme più prestigiose e dai grandi campioni della squadra di Sky Sport. <br><br> Sei interessato?',
  'premium.description3':
    'Per maggiori informazioni sul tuo piano <a href="https://assistenza.sky.it/abbonamento/faq-sky-insider" target="_blank">consulta le FAQ</a>.',
  'premium.description4':
    'Il nuovo spazio editoriale di approfondimento esclusivo firmato Sky: notizie di attualità, opinioni e punti di vista autorevoli, raccontati da giornalisti ed esperti del settore. <br><br> Sei interessato?',
  'premium.description5':
    'Il nuovo spazio editoriale di approfondimento esclusivo firmato Sky: notizie di attualità, opinioni e punti di vista autorevoli, raccontati da giornalisti ed esperti del settore. <br><br> Sky TG24 Insider è offerto da Sky Extra. Sei interessato?',
  'premium.description6':
    'Il nuovo spazio editoriale di approfondimento esclusivo: storie inedite, retroscena e opinioni raccontati dalle firme più prestigiose e dai grandi campioni della squadra di Sky Sport. <br><br> Sky Sport Insider è offerto da Sky Extra. Sei interessato?',

  // Login Bar
  'loginbar.login': 'login',
  'loginbar.logout': 'logout',

  // Video Card Inline
  'videocardinline.is.playing': 'in riproduzione',

  // Disclaimer
  'disclaimer.preroll': 'Il video inizierà dopo questo breve annuncio',
  'disclaimer.redirect': 'Prossimo video in caricamento',

  // Hero Editorial Premium Topic Accordion
  'hero.editorial-premium.topic.accordion.open': 'Leggi di Più',
  'hero.editorial-premium.topic.accordion.close': 'Leggi di Meno',
};
